<template>
  <div class="flex-col bg-white space-y-4 py-4 flex justify-items-center px-4">
    <div class="flex items-center rounded-md border border-gray-100 focus-within:border-blue-200 focus-within:border-2 px-1">
      <input v-model="phoneNumber" type="text" placeholder="Phone number" class="w-full border border-transparent focus:border-transparent focus:ring-0 focus:outline-none">
      <icon-x classes="bg-white w-8 h-8 text-gray-300 hover:text-gray-800" @click="clear()" />
    </div>
    <div class="grid grid-cols-3 gap-4 w-full justify-items-center">
      <button class="border w-full py-2 rounded-lg hover:bg-gray-200" @click="inputDigit(1)">
        1
      </button>
      <button class="border w-full py-2 rounded-lg hover:bg-gray-200" @click="inputDigit(2)">
        2
      </button>
      <button class="border w-full py-2 rounded-lg hover:bg-gray-200" @click="inputDigit(3)">
        3
      </button>
      <button class="border w-full py-2 rounded-lg hover:bg-gray-200" @click="inputDigit(4)">
        4
      </button>
      <button class="border w-full py-2 rounded-lg hover:bg-gray-200" @click="inputDigit(5)">
        5
      </button>
      <button class="border w-full py-2 rounded-lg hover:bg-gray-200" @click="inputDigit(6)">
        6
      </button>
      <button class="border w-full py-2 rounded-lg hover:bg-gray-200" @click="inputDigit(7)">
        7
      </button>
      <button class="border w-full py-2 rounded-lg hover:bg-gray-200" @click="inputDigit(8)">
        8
      </button>
      <button class="border w-full py-2 rounded-lg hover:bg-gray-200" @click="inputDigit(9)">
        9
      </button>
      <button class="border w-full py-2 rounded-lg hover:bg-gray-200" @click="inputDigit('*')">
        *
      </button>
      <button class="border w-full py-2 rounded-lg hover:bg-gray-200" @click="inputDigit(0)">
        0
      </button>
      <button class="border w-full py-2 rounded-lg hover:bg-gray-200" @click="inputDigit('#')">
        #
      </button>
      <button class="col-span-2 flex border w-full py-2 rounded-lg bg-green-500 hover:bg-green-700 justify-center text-white items-center" @click="dialNumber()">
        <phone-outgoing class="w-6 h-6 mr-2" />
        Dial
      </button>
      <button class="flex items-center border w-full py-2 rounded-lg hover:bg-slate-600 justify-center bg-slate-400 text-white" @click="deleteDigit()">
        <ChevronLeft />
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'pinia'

export default {
  setup () {
    const callConsole = useCallConsoleStore()
    return { callConsole }
  },
  data () {
    return {
      phoneNumber: ''
    }
  },
  computed: {
    ...mapState(useCallConsoleStore, [
      'isConsoleReadyForCalls',
      'getConsoleStatus',
      'activeCalls'
    ])
  },
  async mounted () {
    // Only initialize if user is authenticated
    const { loggedIn } = useAuth()
    if (loggedIn.value) {
      await this.callConsole.initialiseDevice()
    }
  },
  methods: {
    inputDigit (digit) {
      this.phoneNumber = this.phoneNumber + digit
    },
    clear () {
      this.phoneNumber = ''
    },
    deleteDigit () {
      let updatedNUmber = ''
      updatedNUmber = this.phoneNumber.substring(0, this.phoneNumber.length - 1)
      this.phoneNumber = updatedNUmber
    },
    dialNumber () {
      if (!this.isConsoleReadyForCalls) {
        this.toast.error('Call console is currently busy or unavailable')
      }

      let formattedPhone = this.phoneNumber
      if (formattedPhone.startsWith('0')) {
        formattedPhone = '+44' + formattedPhone.substring(1)
      }

      this.callConsole.initialiseOutgoing({ phoneNumber: formattedPhone })
    }
  }
}

</script>
